export const buildMobilePaymentDto = ({ record, values, vouId }) => {
  const dto = {
    customerId: record.customerId,
    vouId,
    cardNumber: record.cardNumber,
    mobileAppUserId: values.mobileAppUserId,
    hasMobilePayment: values.hasMobilePayment,
  };

  if (!record.cardType) {
    dto.mobileAppUserId = null;
  }

  if (!values?.mobileAppUserId && record?.mobileAppUserId) {
    dto.hasMobilePayment = null;
    dto.mobileAppUserId = record.mobileAppUserId;
  }

  return dto;
};